export default __webpack_public_path__ + "static/media/logo.ac3cfbda.svg";